import { render, staticRenderFns } from "./ButtonReject.vue?vue&type=template&id=3fecbf07&"
import script from "./ButtonReject.vue?vue&type=script&lang=js&"
export * from "./ButtonReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports